import { render, staticRenderFns } from "./OPZSettings.vue?vue&type=template&id=426fda26&scoped=true"
import script from "./OPZSettings.vue?vue&type=script&lang=ts"
export * from "./OPZSettings.vue?vue&type=script&lang=ts"
import style0 from "./OPZSettings.vue?vue&type=style&index=0&id=426fda26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426fda26",
  null
  
)

export default component.exports